import React, { useState, useCallback, useMemo } from "react";
import { Parameters } from "../MachineTaskConstants";
import FormSkel from "../../../../../components/Modals/FormSkel";

const ParameterChangeForm = ({ isOpen, onClose, onSubmit, generateTaskId }) => {
  const [currentParameter, setCurrentParameter] = useState(0);
  const [parameterValue, setParameterValue] = useState("");
  const [startAt, setStartAt] = useState("");
  const [error, setError] = useState("");

  const currentParam = useMemo(() => Parameters[currentParameter], [currentParameter]);

  const handleValueChange = useCallback((val) => {
    setParameterValue(val);
    if (val === "" || val === null || val === undefined) {
      setError("Proszę podać wartość parametru.");
      return;
    }

    const numVal = Number(val);
    if (isNaN(numVal)) {
      setError("Wprowadzona wartość musi być liczbą.");
    } else if (numVal < currentParam.min || numVal > currentParam.max) {
      setError(`Wartość parametru musi mieścić się w przedziale od ${currentParam.min} do ${currentParam.max}.`);
    } else {
      setError("");
    }
  }, [currentParam]);

  const handleParamSelect = useCallback((index) => {
    setCurrentParameter(index);
    setParameterValue("");
    setError("");
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    
    if (!parameterValue) {
      setError("Proszę podać wartość parametru.");
      return;
    }

    const numVal = Number(parameterValue);
    if (isNaN(numVal) || numVal < currentParam.min || numVal > currentParam.max) {
      setError(`Wartość parametru musi mieścić się w przedziale od ${currentParam.min} do ${currentParam.max}.`);
      return;
    }

    const parameterAddress = currentParam.address;
    const task = {
      id: generateTaskId(),
      taskType: "PARAM_CHANGE",
      parameterAddress,
      value: parameterValue,
      startAt: startAt || null,
      datetimeType: startAt ? "single" : null,
    };
    
    onSubmit(task);
    setStartAt("");
    setParameterValue("");
    setCurrentParameter(0);
    setError("");
  }, [parameterValue, currentParam, startAt, onSubmit, generateTaskId]);

  const handleClose = useCallback(() => {
    setStartAt("");
    setParameterValue("");
    setCurrentParameter(0);
    setError("");
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <FormSkel
      headerText="Zmiana parametru płyty VMC"
      handleClose={handleClose}
      acceptForm="true"
    >
      <div>
        <form onSubmit={handleSubmit} id="modal-form">
          <div className="form-group">
            <label htmlFor="name" className="form-label font-weight-bold">
              Wybierz parametr
            </label>
            <select
              className="form-control"
              id="name"
              name="name"
              value={currentParameter}
              onChange={(e) => handleParamSelect(Number(e.target.value))}
              required
            >
              {Parameters.map((parameter, index) => (
                <option key={index} value={index}>
                  [Adres {parameter.address}] {parameter.desc}
                </option>
              ))}
            </select>
            <small className="form-text text-muted">
              Opis: {currentParam.desc}
            </small>
          </div>
          
          <div className="form-group">
            <label htmlFor="value" className="form-label font-weight-bold">
              Nowa wartość parametru
            </label>
            <input
              type="number"
              className={`form-control ${error ? 'is-invalid' : parameterValue ? 'is-valid' : ''}`}
              id="value"
              name="value"
              value={parameterValue}
              onChange={(e) => handleValueChange(e.target.value)}
              placeholder={`Zakres: ${currentParam.min} - ${currentParam.max}`}
              min={currentParam.min}
              max={currentParam.max}
              required
            />
            {error ? (
              <div className="invalid-feedback d-block text-danger font-weight-bold mt-1">
                {error}
              </div>
            ) : (
              <small className="form-text text-muted">
                Dopuszczalny zakres wartości: <strong>{currentParam.min}</strong> – <strong>{currentParam.max}</strong>
              </small>
            )}
          </div>
          
          <div className="form-group mb-0">
            <label htmlFor="datetimeChange" className="form-label font-weight-bold">
              Kiedy wykonać zmiane (opcjonalnie)
            </label>
            <input
              type="datetime-local"
              className="form-control"
              id="datetimeChange"
              value={startAt}
              onChange={(e) => setStartAt(e.target.value)}
            />
            <small className="form-text text-muted">
              Pozostaw puste dla natychmiastowego wykonania.
            </small>
          </div>
        </form>
      </div>
    </FormSkel>
  );
};

export default ParameterChangeForm;
